import { Controller } from "@hotwired/stimulus";
import { initPayslipsDatatable } from "../../datatables/payslips_datatable";
import { isDatatableUninitialized } from "../../datatables/datatable_functions";

export default class extends Controller {
  initialize() {
    if (isDatatableUninitialized(this.element)) {
      initPayslipsDatatable(this.element);
    }
  }
}
